import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  TextInput,
  FlatList,
  RefreshControl,
  ActivityIndicator,
} from 'react-native';
import { Ionicons, MaterialIcons, FontAwesome5 } from '@expo/vector-icons';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function AllOpportunitiesScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_allopportunitiesscreen`;
    apiFetch('/api/data/jobs?is_active=true&sort=created_at&order=desc&limit=50').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [opportunities, setOpportunities] = useState([]);
  const [filteredOpportunities, setFilteredOpportunities] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedSort, setSelectedSort] = useState('Deadline');

  // Filter options
  const filterOptions = [
    'All',
    'Internships',
    'Graduate Programs',
    'Entry Level',
    'Career Fairs',
    'Mentorship',
  ];

  // Sort options
  const sortOptions = [
    { label: 'Deadline', value: 'deadline' },
    { label: 'Recent', value: 'recent' },
    { label: 'Company', value: 'company' },
  ];

  // Mock opportunities data
  const mockOpportunities = [
    // Internships
    {
      id: 'intern1',
      title: 'Software Engineering Intern',
      company: 'Google',
      location: 'London, UK',
      type: 'Internship',
      field: 'Technology',
      deadline: '2025-07-15',
      duration: '12 weeks',
      compensation: '£2,000/month',
      logo: 'https://logo.clearbit.com/google.com',
      isRemote: false,
      postedDate: '2025-05-01',
    },
    {
      id: 'intern2',
      title: 'Mechanical Engineering Intern',
      company: 'Rolls-Royce',
      location: 'Derby, UK',
      type: 'Internship',
      field: 'Engineering',
      deadline: '2025-06-30',
      duration: '6 months',
      compensation: '£1,800/month',
      logo: 'https://logo.clearbit.com/rolls-royce.com',
      isRemote: false,
      postedDate: '2025-05-05',
    },
    {
      id: 'intern3',
      title: 'UX Design Intern',
      company: 'BBC',
      location: 'Manchester, UK',
      type: 'Internship',
      field: 'Design',
      deadline: '2025-08-01',
      duration: '3 months',
      compensation: '£1,700/month',
      logo: 'https://logo.clearbit.com/bbc.co.uk',
      isRemote: true,
      postedDate: '2025-05-10',
    },

    // Graduate Programs
    {
      id: 'grad1',
      title: 'Engineering Leadership Program',
      company: 'Rolls-Royce',
      location: 'Derby, UK',
      type: 'Graduate Program',
      field: 'Engineering',
      deadline: '2025-11-15',
      duration: '2 years',
      compensation: '£32,000/year',
      logo: 'https://logo.clearbit.com/rolls-royce.com',
      isRemote: false,
      postedDate: '2025-04-15',
    },
    {
      id: 'grad2',
      title: 'Technology Graduate Scheme',
      company: 'BP',
      location: 'London, UK',
      type: 'Graduate Program',
      field: 'Technology',
      deadline: '2025-10-30',
      duration: '3 years',
      compensation: '£35,000/year',
      logo: 'https://logo.clearbit.com/bp.com',
      isRemote: false,
      postedDate: '2025-04-20',
    },
    {
      id: 'grad3',
      title: 'Civil Engineering Graduate Programme',
      company: 'Arup',
      location: 'Multiple UK Locations',
      type: 'Graduate Program',
      field: 'Civil Engineering',
      deadline: '2025-12-01',
      duration: '2 years',
      compensation: '£30,000/year',
      logo: 'https://logo.clearbit.com/arup.com',
      isRemote: false,
      postedDate: '2025-04-25',
    },

    // Entry Level Jobs
    {
      id: 'entry1',
      title: 'Junior Software Developer',
      company: 'Arm',
      location: 'Cambridge, UK',
      type: 'Entry Level',
      field: 'Technology',
      deadline: '2025-07-30',
      compensation: '£40,000/year',
      logo: 'https://logo.clearbit.com/arm.com',
      isRemote: true,
      postedDate: '2025-05-12',
    },
    {
      id: 'entry2',
      title: 'Graduate Structural Engineer',
      company: 'WSP',
      location: 'Birmingham, UK',
      type: 'Entry Level',
      field: 'Engineering',
      deadline: '2025-08-15',
      compensation: '£28,000/year',
      logo: 'https://logo.clearbit.com/wsp.com',
      isRemote: false,
      postedDate: '2025-05-15',
    },
    {
      id: 'entry3',
      title: 'Assistant Product Designer',
      company: 'Dyson',
      location: 'Malmesbury, UK',
      type: 'Entry Level',
      field: 'Design',
      deadline: '2025-09-01',
      compensation: '£32,000/year',
      logo: 'https://logo.clearbit.com/dyson.com',
      isRemote: false,
      postedDate: '2025-05-18',
    },

    // Career Fairs
    {
      id: 'fair1',
      title: 'Engineering Careers Fair 2025',
      company: 'University of Manchester',
      location: 'Manchester, UK',
      type: 'Career Fair',
      field: 'Engineering',
      deadline: '2025-09-15',
      date: '2025-09-20',
      logo: 'https://logo.clearbit.com/manchester.ac.uk',
      isRemote: false,
      postedDate: '2025-05-20',
      participants: ['Rolls-Royce', 'BAE Systems', 'Airbus', 'Siemens', 'Arup'],
    },
    {
      id: 'fair2',
      title: 'London Tech Job Fair',
      company: 'TechMeetups',
      location: 'London, UK',
      type: 'Career Fair',
      field: 'Technology',
      deadline: '2025-08-10',
      date: '2025-08-15',
      logo: 'https://logo.clearbit.com/techmeetups.com',
      isRemote: false,
      postedDate: '2025-05-22',
      participants: ['Google', 'Microsoft', 'Amazon', 'Meta', 'Spotify'],
    },

    // Mentorship Programs
    {
      id: 'mentor1',
      title: 'Women in Engineering Mentorship',
      company: 'WES',
      location: 'Virtual',
      type: 'Mentorship',
      field: 'Engineering',
      deadline: '2025-07-01',
      duration: '6 months',
      logo: 'https://logo.clearbit.com/wes.org.uk',
      isRemote: true,
      postedDate: '2025-05-25',
    },
    {
      id: 'mentor2',
      title: 'Early Career Tech Mentorship',
      company: 'TechUK',
      location: 'Virtual',
      type: 'Mentorship',
      field: 'Technology',
      deadline: '2025-08-01',
      duration: '12 months',
      logo: 'https://logo.clearbit.com/techuk.org',
      isRemote: true,
      postedDate: '2025-05-28',
    },
  ];

  // Load opportunities
  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setOpportunities(mockOpportunities);
      setFilteredOpportunities(mockOpportunities);
      setIsLoading(false);
    }, 1500);
  }, []);

  // Filter and sort opportunities
  useEffect(() => {
    let filtered = [...opportunities];

    // Apply type filter
    if (selectedFilter !== 'All') {
      filtered = filtered.filter(item => item.type === selectedFilter);
    }

    // Apply search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        item =>
          String(item.title ?? '').toLowerCase().includes(query) ||
          String(item.company ?? '').toLowerCase().includes(query) ||
          String(item.location ?? '').toLowerCase().includes(query) ||
          String(item.field ?? '').toLowerCase().includes(query)
      );
    }

    // Apply sorting
    switch (selectedSort) {
      case 'Deadline':
        filtered.sort((a, b) => new Date(a.deadline) - new Date(b.deadline));
        break;
      case 'Recent':
        filtered.sort(
          (a, b) => new Date(b.postedDate) - new Date(a.postedDate)
        );
        break;
      case 'Company':
        filtered.sort((a, b) => a.company.localeCompare(b.company));
        break;
      default:
        break;
    }

    setFilteredOpportunities(filtered);
  }, [opportunities, selectedFilter, searchQuery, selectedSort]);

  // Format date
  const formatDate = dateString => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Calculate days remaining
  const getDaysRemaining = deadlineDate => {
    const today = new Date();
    const deadline = new Date(deadlineDate);
    const diffTime = deadline - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Handle opportunity press
  const handleOpportunityPress = item => {
    switch (item.type) {
      case 'Internship':
        navigation.navigate('InternshipDetails', { internshipId: item.id });
        break;
      case 'Graduate Program':
        navigation.navigate('GraduatePrograms', { programId: item.id });
        break;
      case 'Entry Level':
        navigation.navigate('EntryLevelJobs', { jobId: item.id });
        break;
      case 'Career Fair':
        navigation.navigate('CareerFairs', { fairId: item.id });
        break;
      case 'Mentorship':
        navigation.navigate('MentorshipPrograms', { mentorshipId: item.id });
        break;
      default:
        break;
    }
  };

  // Render opportunity item
  const renderOpportunityItem = ({ item }) => {
    const daysRemaining = getDaysRemaining(item.deadline);
    const isUrgent = daysRemaining <= 7 && daysRemaining > 0;
    const isPast = daysRemaining < 0;

    return (
      <TouchableOpacity
        style={styles.opportunityCard}
        onPress={() => handleOpportunityPress(item)}
      >
        <View style={styles.opportunityHeader}>
          <View style={styles.companyLogoContainer}>
            <Image
              source={{ uri: (item.logo && item.logo.startsWith('http')) ? item.logo : undefined }}
              style={styles.companyLogo}
              defaultSource={require('../../../assets/default-company.png')}
            />
          </View>
          <View style={styles.opportunityHeaderContent}>
            <Text style={styles.opportunityTitle} numberOfLines={2}>
              {item.title}
            </Text>
            <Text style={styles.companyName}>{item.company}</Text>
            <View style={styles.locationContainer}>
              <Ionicons name="location-outline" size={14} color="#64748B" />
              <Text style={styles.locationText}>{item.location}</Text>
              {item.isRemote && (
                <View style={styles.remoteBadge}>
                  <Text style={styles.remoteBadgeText}>Remote</Text>
                </View>
              )}
            </View>
          </View>
        </View>

        <View style={styles.opportunityDetails}>
          <View style={styles.typeBadgeContainer}>
            <View
              style={[
                styles.typeBadge,
                item.type === 'Internship' && styles.internshipBadge,
                item.type === 'Graduate Program' && styles.graduateBadge,
                item.type === 'Entry Level' && styles.entryLevelBadge,
                item.type === 'Career Fair' && styles.careerFairBadge,
                item.type === 'Mentorship' && styles.mentorshipBadge,
              ]}
            >
              <Text style={styles.typeBadgeText}>{item.type}</Text>
            </View>
            <View style={styles.fieldBadge}>
              <Text style={styles.fieldBadgeText}>{item.field}</Text>
            </View>
          </View>

          {item.duration && (
            <View style={styles.detailItem}>
              <Ionicons name="time-outline" size={14} color="#64748B" />
              <Text style={styles.detailText}>{item.duration}</Text>
            </View>
          )}

          {item.compensation && (
            <View style={styles.detailItem}>
              <Ionicons name="cash-outline" size={14} color="#64748B" />
              <Text style={styles.detailText}>{item.compensation}</Text>
            </View>
          )}

          {item.date && (
            <View style={styles.detailItem}>
              <Ionicons name="calendar-outline" size={14} color="#64748B" />
              <Text style={styles.detailText}>{formatDate(item.date)}</Text>
            </View>
          )}

          <View style={styles.deadlineContainer}>
            <Text
              style={[
                styles.deadlineLabel,
                isUrgent && styles.urgentDeadlineLabel,
                isPast && styles.pastDeadlineLabel,
              ]}
            >
              {isPast ? 'Closed' : 'Deadline:'}
            </Text>
            <Text
              style={[
                styles.deadlineDate,
                isUrgent && styles.urgentDeadlineDate,
                isPast && styles.pastDeadlineDate,
              ]}
            >
              {formatDate(item.deadline)}
            </Text>
            {!isPast && (
              <Text
                style={[
                  styles.daysRemaining,
                  isUrgent && styles.urgentDaysRemaining,
                ]}
              >
                {daysRemaining === 0
                  ? 'Today'
                  : daysRemaining === 1
                    ? 'Tomorrow'
                    : `${daysRemaining} days left`}
              </Text>
            )}
          </View>
        </View>

        <View style={styles.opportunityFooter}>
          <TouchableOpacity
            style={[styles.applyButton, isPast && styles.disabledButton]}
            onPress={() => {
              if (!isPast) {
                switch (item.type) {
                  case 'Internship':
                    navigation.navigate('InternshipApplication', {
                      internshipId: item.id,
                    });
                    break;
                  case 'Graduate Program':
                    navigation.navigate('GraduateProgramApplication', {
                      programId: item.id,
                    });
                    break;
                  case 'Entry Level':
                    navigation.navigate('JobApplication', { jobId: item.id });
                    break;
                  case 'Career Fair':
                    navigation.navigate('CareerFairRegistration', {
                      fairId: item.id,
                    });
                    break;
                  case 'Mentorship':
                    navigation.navigate('MentorshipApplication', {
                      mentorshipId: item.id,
                    });
                    break;
                  default:
                    break;
                }
              }
            }}
            disabled={isPast}
          >
            <Text
              style={[
                styles.applyButtonText,
                isPast && styles.disabledButtonText,
              ]}
            >
              {isPast
                ? 'Closed'
                : item.type === 'Career Fair'
                  ? 'Register'
                  : item.type === 'Mentorship'
                    ? 'Apply'
                    : 'Apply Now'}
            </Text>
            {!isPast && (
              <Ionicons name="arrow-forward" size={16} color="#ffffff" />
            )}
          </TouchableOpacity>

          <TouchableOpacity style={styles.saveButton}>
            <Ionicons name="bookmark-outline" size={20} color="#0e4e96" />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // Render empty state
  const renderEmptyState = () => (
    <View style={styles.emptyStateContainer}>
      <Ionicons name="search" size={60} color="#CBD5E1" />
      <Text style={styles.emptyStateTitle}>No opportunities found</Text>
      <Text style={styles.emptyStateMessage}>
        Try adjusting your search or filters to find more opportunities.
      </Text>
    </View>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>All Opportunities</Text>
        <JobengLogo />
      </View>

      {/* Search Bar */}
      <View style={styles.searchContainer}>
        <View style={styles.searchInputContainer}>
          <Ionicons
            name="search"
            size={20}
            color="#64748B"
            style={styles.searchIcon}
          />
          <TextInput
            style={styles.searchInput}
            placeholder="Search opportunities..."
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity
              style={styles.clearButton}
              onPress={() => setSearchQuery('')}
            >
              <Ionicons name="close-circle" size={18} color="#94A3B8" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Filter Tabs */}
      <View style={styles.filterContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filterScrollContent}
        >
          {filterOptions.map(filter => (
            <TouchableOpacity
              key={filter}
              style={[
                styles.filterTab,
                selectedFilter === filter && styles.selectedFilterTab,
              ]}
              onPress={() => setSelectedFilter(filter)}
            >
              <Text
                style={[
                  styles.filterTabText,
                  selectedFilter === filter && styles.selectedFilterTabText,
                ]}
              >
                {filter}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Sort Options */}
      <View style={styles.sortContainer}>
        <Text style={styles.sortLabel}>Sort by:</Text>
        {sortOptions.map(option => (
          <TouchableOpacity
            key={option.value}
            style={[
              styles.sortOption,
              selectedSort === option.label && styles.selectedSortOption,
            ]}
            onPress={() => setSelectedSort(option.label)}
          >
            <Text
              style={[
                styles.sortOptionText,
                selectedSort === option.label && styles.selectedSortOptionText,
              ]}
            >
              {option.label}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading opportunities...</Text>
        </View>
      ) : (
        <FlatList
          data={filteredOpportunities}
          renderItem={renderOpportunityItem}
          keyExtractor={item => item.id}
          contentContainerStyle={styles.listContent}
          showsVerticalScrollIndicator={false}
          ListEmptyComponent={renderEmptyState}
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  searchContainer: {
    padding: 16,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  searchInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  searchIcon: {
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    height: 40,
    fontSize: 16,
    color: '#0F172A',
  },
  clearButton: {
    padding: 4,
  },
  filterContainer: {
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  filterScrollContent: {
    paddingHorizontal: 12,
    paddingVertical: 12,
  },
  filterTab: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#F1F5F9',
    marginHorizontal: 4,
  },
  selectedFilterTab: {
    backgroundColor: '#0e4e96',
  },
  filterTabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
  },
  selectedFilterTabText: {
    color: '#ffffff',
  },
  sortContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  sortLabel: {
    fontSize: 14,
    color: '#64748B',
    marginRight: 8,
  },
  sortOption: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 4,
    marginHorizontal: 4,
  },
  selectedSortOption: {
    backgroundColor: '#EBF5FF',
  },
  sortOptionText: {
    fontSize: 14,
    color: '#64748B',
  },
  selectedSortOptionText: {
    color: '#0e4e96',
    fontWeight: '500',
  },
  listContent: {
    padding: 16,
  },
  opportunityCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    marginBottom: 16,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  opportunityHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  companyLogoContainer: {
    marginRight: 12,
  },
  companyLogo: {
    width: 50,
    height: 50,
    borderRadius: 8,
    backgroundColor: '#F1F5F9',
  },
  opportunityHeaderContent: {
    flex: 1,
  },
  opportunityTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 4,
  },
  companyName: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 4,
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  locationText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
    marginRight: 8,
  },
  remoteBadge: {
    backgroundColor: '#E0F2FE',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  remoteBadgeText: {
    fontSize: 10,
    color: '#0284C7',
    fontWeight: '500',
  },
  opportunityDetails: {
    marginBottom: 12,
  },
  typeBadgeContainer: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  typeBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    marginRight: 8,
    backgroundColor: '#F1F5F9',
  },
  internshipBadge: {
    backgroundColor: '#EDE9FE',
  },
  graduateBadge: {
    backgroundColor: '#DCFCE7',
  },
  entryLevelBadge: {
    backgroundColor: '#FEF3C7',
  },
  careerFairBadge: {
    backgroundColor: '#FEE2E2',
  },
  mentorshipBadge: {
    backgroundColor: '#DBEAFE',
  },
  typeBadgeText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#64748B',
  },
  fieldBadge: {
    backgroundColor: '#F1F5F9',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
  },
  fieldBadgeText: {
    fontSize: 12,
    color: '#64748B',
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  detailText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
  },
  deadlineContainer: {
    marginTop: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  deadlineLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: '#64748B',
    marginRight: 4,
  },
  urgentDeadlineLabel: {
    color: '#EF4444',
  },
  pastDeadlineLabel: {
    color: '#94A3B8',
  },
  deadlineDate: {
    fontSize: 12,
    color: '#0F172A',
    fontWeight: '500',
  },
  urgentDeadlineDate: {
    color: '#EF4444',
  },
  pastDeadlineDate: {
    color: '#94A3B8',
  },
  daysRemaining: {
    fontSize: 12,
    color: '#0F172A',
    fontWeight: '500',
    marginLeft: 8,
    backgroundColor: '#F1F5F9',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  urgentDaysRemaining: {
    backgroundColor: '#FEE2E2',
    color: '#EF4444',
  },
  opportunityFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8,
  },
  applyButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  disabledButton: {
    backgroundColor: '#E2E8F0',
  },
  applyButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
    marginRight: 8,
  },
  disabledButtonText: {
    color: '#94A3B8',
  },
  saveButton: {
    padding: 8,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748B',
  },
  emptyStateContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  emptyStateTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#0F172A',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateMessage: {
    fontSize: 14,
    color: '#64748B',
    textAlign: 'center',
  },
});
